import { getFormValues } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { trackToSAction } from './gaTracking';

import {
    clearAuthNotification,
    showAuthNotification,
    cleanSocialAuthenticationData,
} from './auth';

import { handleSocialLogin } from './social';

import { handleAppleSocialLogin } from './appleLogin';

import {
    GA_APPLE,
    GA_EVENTBRITE,
    TOSMODAL_SOCIAL_ACCEPTED,
} from '../constants/analytics';
import { LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT } from '../constants';

/**  ACTION CREATORS  **/
export const SET_TOS_SOCIAL_STATUS = 'SET_TOS_SOCIAL_STATUS';
export const setTosSocialStatus = (payload) => ({
    type: SET_TOS_SOCIAL_STATUS,
    payload,
});
export const SET_SHOW_TOS = 'SET_SHOW_TOS';
export const setShowToS = (show) => ({
    type: SET_SHOW_TOS,
    payload: show,
});
export const SET_TOS_SOCIAL_ACCEPTED = 'SET_TOS_SOCIAL_ACCEPTED';
export const setTosSocialAccepted = (payload) => ({
    type: SET_TOS_SOCIAL_ACCEPTED,
    payload,
});

export const getSourceProvider = ({ state }) => {
    let {
        social: { socialProvider: sourceProvider = '' },
    } = state;
    const query = state.routing.locationBeforeTransitions.query;

    if (query['external_provider']) {
        sourceProvider = query['external_provider'];
    } else if (isEmpty(sourceProvider)) {
        sourceProvider = GA_EVENTBRITE;
    }
    return sourceProvider;
};
export const acceptToS = ({
    onAccept,
    formName,
    actionName,
    trackLabel = null,
}) => (dispatch, getState) => {
    const state = getState();

    const sourceProvider = trackLabel
        ? trackLabel
        : getSourceProvider({ state });
    trackToSAction({ state, sourceProvider, actionName });
    dispatch(clearAuthNotification());
    dispatch(setShowToS(false));
    const formData = getFormValues(formName)(state);
    dispatch(setTosSocialAccepted(true));
    onAccept(formData);
};

export const cancelToS = ({
    actionName,
    notificationMessage,
    trackLabel = null,
}) => (dispatch, getState) => {
    const state = getState();

    const sourceProvider = trackLabel
        ? trackLabel
        : getSourceProvider({ state });

    trackToSAction({ state, sourceProvider, actionName });
    dispatch(
        showAuthNotification({
            message: notificationMessage,
        }),
    );
    dispatch(setShowToS(false));
    dispatch(cleanSocialAuthenticationData());
};

export const showToS = ({ actionName, trackLabel = null }) => (
    dispatch,
    getState,
) => {
    const state = getState();
    const sourceProvider = trackLabel
        ? trackLabel
        : getSourceProvider({ state });

    dispatch(clearAuthNotification());
    dispatch(setShowToS(true));
    dispatch(setTosSocialAccepted(false));
    trackToSAction({ state, sourceProvider, actionName });
};
export const acceptSocialToS = () => (dispatch, getState) => {
    const state = getState();
    const {
        social: { socialData, socialProvider: sourceProvider },
        status: { tosSocialStatus },
    } = state;

    trackToSAction({
        state,
        sourceProvider,
        actionName: TOSMODAL_SOCIAL_ACCEPTED,
    });
    dispatch(clearAuthNotification());
    dispatch(setShowToS(false));
    dispatch(setTosSocialAccepted(true));
    if (sourceProvider === GA_APPLE) {
        if (tosSocialStatus === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT) {
            handleAppleSocialLogin({
                data: socialData[sourceProvider],
                getState,
                dispatch,
                isSoftAccount: true,
            });
        }
    } else {
        dispatch(
            handleSocialLogin({
                data: socialData[sourceProvider],
            }),
        );
    }
};
